module.exports = __webpack_public_path__ + "img/WeChat69c9771818a4986471497c4750f99b75.69c97718.png";